/**
 * @generated SignedSource<<13f37f313fb280ce251a7e067d116a1f>>
 * @relayHash 55906b3f09b495e23a1e9e44dd8cfb40
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7327e01e3eb0ca7b43489a9816f84adb8b2e2c70c9e70f0d1b83787a2dfdf5fd

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_timelineQuery } from './src_timelineQuery.graphql';

import isJiraItrM4Exp3Enabled_provider from '@atlassian/jira-relay-provider/src/is-jira-itr-m4-exp-3-enabled.relayprovider';
import isJscIFCEnabled_provider from '@atlassian/jira-relay-provider/src/is-jsc-ifc-enabled.relayprovider';
import isJscInfiniteScrollEnabled_provider from '@atlassian/jira-relay-provider/src/is-jsc-infinite-scroll-enabled.relayprovider';
import isRenderJiraWatchesFieldNINEnabled_provider from '@atlassian/jira-relay-provider/src/is-render-jirawatchesfield-nin.relayprovider';
import isSavedListViewTechnicalChangesEnabled_provider from '@atlassian/jira-relay-provider/src/is-saved-list-view-technical-changes-enabled.relayprovider';
import isJiraSingleLineRowHeightEnabled_provider from '@atlassian/jira-relay-provider/src/is-single-line-row-height-enabled.relayprovider';
import isCheckIssueCreatePermissionsEnabled_provider from '@atlassian/jira-relay-provider/src/jira-list-check-issue-create-permissions.relayprovider';
import isReparentingEnabled_provider from '@atlassian/jira-relay-provider/src/jira-list-reparenting.relayprovider';
import isNumberFieldConfigurableEnabled_provider from '@atlassian/jira-relay-provider/src/jira-number-field-configuration-enabled.relayprovider';
import isJscInlineEditRefactorEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-inline-editing-field-refactor.relayprovider';
import isJscInlineEditFlagFixEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-inline-editing-flag-fix.relayprovider';
import isJscM2Enabled_provider from '@atlassian/jira-relay-provider/src/jsc-m2-fe-changes.relayprovider';
import isJscMergedColumnEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-merged-column.relayprovider';
import isMultiGroupPickerCellEnabled_provider from '@atlassian/jira-relay-provider/src/nin-multi-group-picker-cell.relayprovider';
import includeSingleSelectColorField_provider from '@atlassian/jira-relay-provider/src/thor-colorful-single-select-milestone2-experiment.relayprovider';

const node: PreloadableConcreteRequest<src_timelineQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "7327e01e3eb0ca7b43489a9816f84adb8b2e2c70c9e70f0d1b83787a2dfdf5fd",
    "metadata": {},
    "name": "src_timelineQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": isJscIFCEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": isReparentingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistcheckissuecreatepermissionsrelayprovider": isCheckIssueCreatePermissionsEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider": isSavedListViewTechnicalChangesEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": isJscInfiniteScrollEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": isJscM2Enabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": isJscMergedColumnEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": isJiraItrM4Exp3Enabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": isJscInlineEditRefactorEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": isMultiGroupPickerCellEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": isJscInlineEditFlagFixEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": isRenderJiraWatchesFieldNINEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": isJiraSingleLineRowHeightEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": includeSingleSelectColorField_provider
    }
  }
};

export default node;
